import setStartWorkflowState from './setStartWorkflowState';
import { initialStartWorkflowState } from './state';

export default function clearState() {
  setStartWorkflowState(initialStartWorkflowState);
}
